import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-common-react';

export enum RoutesIds {
  issues = 'issues',
  issue = 'issue',
  observations = 'observations',
}

enum ExternalRoutesIds {
  chat = 'chat',
  github = 'github',
  slack = 'slack',
  dataWarehouse = 'dataWarehouse',
  connectors = 'connectors',
}

export const issuesRouteRef = createPageRoute({
  id: 'issue-index',
  page: { title: 'Loop' },
});

export const rootRouteRef = issuesRouteRef;

export const observationsRouteRef = createPageRoute({
  id: 'observation-index',
  route: { path: '/observations', parent: rootRouteRef },
  page: { title: 'Observations' },
});

export const issueRouteRef = createPageRoute({
  id: RoutesIds.issue,
  route: { path: '/:id', parent: rootRouteRef },
  page: { title: 'Issue' },
});

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const githubRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.github,
  optional: true,
});

export const slackRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.slack,
  optional: true,
});

export const dataWarehouseRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.dataWarehouse,
  optional: true,
});

export const connectorsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.connectors,
  optional: true,
});

export const Routes = {
  issues: issuesRouteRef,
  issue: issueRouteRef,
  observations: observationsRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  chat: chatRouteRef,
  github: githubRouteRef,
  slack: slackRouteRef,
  dataWarehouse: dataWarehouseRouteRef,
  connectors: connectorsRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
